function terminateBenefit(memberId, groupId) {
  // TODO: Impelement this funciton. No End poit yet for this.
  // Might have to be part of a different story.
}

export default terminateBenefit;
